import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectivePreloadingStrategy } from "./selective-preloading-strategy";

const appRoutes: Routes = [
  // {
  //   path: 'home',
  //   loadChildren: 'src/app/pages/home/home.module#HomeModule'
  // },
  // {
  //   path: 'pdf',
  //   loadChildren: 'src/app/pages/pdf/pdf.module#PDFModule',
  //   data: { preload: true }
  // },
  {
    path: 'esign',
    loadChildren: 'src/app/pages/esign/esign.module#EsignModule',
    data: { preload: true }
  },
  // {
  //   path: 'auth',
  //   loadChildren: 'src/app/pages/auth/auth.module#AuthModule',
  //   data: { preload: true }
  // },
  // {
  //   path: 'mc',
  //   loadChildren: 'src/app/pages/mc/mc.module#MCModule',
  //   data: { preload: true }
  // },
  // {
  //   path: 'inpixio',
  //   loadChildren: 'src/app/pages/inpixio/inpixio.module#InPixioModule',
  //   data: { preload: true }
  // },
  {
    path: "",
    redirectTo: "esign",
    pathMatch: "full"
  },
  {
    path: "**",
    loadChildren: 'src/app/pages/page-not-found/page-not-found.module#PageNotFoundModule'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        preloadingStrategy: SelectivePreloadingStrategy
      }
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
